"use client";
import { Spinner } from "@/utils/bootstrap";
import ReviewDetails from "../current-reviews/ReviewDetails";
import { useGetAllProductReviewsInfiniteQuery } from "@/api/AppApi/services/reviews";
import usePopup from "@/hooks/usePopup";
import {
  productReviewsPopupAtoms,
  submitproductReviewPopupAtoms,
} from "@/hooks/headerHooks";
import { useIsMobile } from "@/hooks/useIsMobile";
import ProductReviewCard from "../product-reviews/ProductReviewCard/ProductReviewCard";
import { useTranslation } from "@/hooks/localization/useTranslations";
import ReviewsModal from "./ReviewsModal";
import ModalActionBtn from "./ModalActionBtn";

interface Props {}
const ProductReviews: React.FC<Props> = ({}) => {
  const t = useTranslation();
  const isMobile = useIsMobile();
  const mClass = isMobile ? "-mobile" : "";
  const { handleClosePopup, popupValue } = usePopup(productReviewsPopupAtoms);
  const { handleOpenPopup } = usePopup(submitproductReviewPopupAtoms);
  const getProductReviews = useGetAllProductReviewsInfiniteQuery({
    params: { product_id: popupValue?.product_id! },
    enabled: !!popupValue,
  });
  const data = getProductReviews?.data?.pages
    ?.map((page) => page?.result?.data)
    ?.flat();
  return (
    <ReviewsModal
      title={t.item_review}
      popupValue={popupValue!}
      handleClosePopup={handleClosePopup}
      ModalActionBtn={
        popupValue?.canReview ? (
          <ModalActionBtn
            label={t.write_your_review}
            onClick={() =>
              handleOpenPopup({ product_id: popupValue?.product_id! })
            }
          />
        ) : undefined
      }
    >
      <ReviewDetails
        menu
        rate={popupValue?.rate!}
        ratings={popupValue?.ratings!}
        flexColumn
      />
      {data?.map((review) => (
        <ProductReviewCard
          key={review.id}
          {...review}
          product_id={popupValue?.product_id!!}
          onClickAction={() => getProductReviews?.refetch()}
        />
      ))}

      {getProductReviews && getProductReviews?.hasNextPage && (
        <div
          className={`show-more-replies${mClass}`}
          onClick={() => getProductReviews?.fetchNextPage()}
        >
          {t.show_more}
        </div>
      )}
      {getProductReviews?.isFetching && (
        <div className="w-100 d-flex justify-content-center">
          <Spinner className="comment-spinner" />
        </div>
      )}
    </ReviewsModal>
  );
};

export default ProductReviews;
